/* ============================================================
   Meta Pixel helpers — "Damone Bush's Pixel" (496385990705216),
   the same dataset instapass.store already reports to.

   The base code lives in public/index.html. These helpers only fire
   events, and they never throw: tracking must never break checkout.

   eventID is passed on Purchase so that, when Conversions API is
   added server-side, Meta can de-duplicate browser + server events.
   ============================================================ */

import { trackTikTok } from "./tiktokPixel";

function fbqSafe(...args) {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq(...args);
    }
  } catch (e) {
    /* tracking is never allowed to break the page */
  }
}

/** Standard events: PageView, CompleteRegistration, InitiateCheckout, Purchase … */
export function trackMeta(eventName, params = {}, eventId) {
  if (eventId) fbqSafe("track", eventName, params, { eventID: String(eventId) });
  else fbqSafe("track", eventName, params);
  trackTikTok(eventName, params, eventId);
}

/** Custom events, e.g. ProfileCompleted. */
export function trackMetaCustom(eventName, params = {}) {
  fbqSafe("trackCustom", eventName, params);
}

/** MILO's anonymous visitor id (set by innerface.co/assets/milo-touch.js), or null. */
export function miloAnonId() {
  try {
    return (window.MILO_TOUCH && window.MILO_TOUCH.anonId()) || null;
  } catch (e) {
    return null;
  }
}
